export default __webpack_public_path__ + "static/media/walk.d33bf83c.svg";